import { Link } from '@tanstack/react-router';
import { css } from 'styled-system/css';
import { t } from '@/ui/i18n';
import { AppShell } from './AppShell';
import { BackHeader } from './BackHeader';
import { NotFoundScreen } from './NotFoundScreen';
import { GateLoadingScreen } from './GateLoadingScreen';
import { useBillingGate } from './useBillingGate';

const title = css({ fontFamily: 'wsDisplay', fontWeight: 'semibold', fontSize: '26px', lineHeight: '1.1', color: 'ws.jadeInk', margin: '0 0 16px' });
const statusCard = css({ bg: 'ws.card', borderRadius: '18px', padding: '16px', boxShadow: '0 1px 2px rgba(33,75,64,0.05), 0 10px 22px rgba(33,75,64,0.08)', fontFamily: 'wsUi', fontSize: '15px', fontWeight: 'semibold', color: 'ws.jadeInk', margin: '0 0 14px' });
const lede = css({ fontFamily: 'wsUi', fontSize: '14px', lineHeight: '1.5', color: 'ws.khaki', margin: '0 0 18px' });
// ws.sakuraDark (not ws.sakura) clears WCAG AA for coloured text — known palette gotcha.
const linkStyle = css({ fontFamily: 'wsUi', fontSize: '14px', fontWeight: 'bold', color: 'ws.sakuraDark', textDecoration: 'underline' });

export function CheckoutCancelScreen() {
  return (
    <AppShell variant="flow" topBar={<BackHeader to="/reglages" />} backTo="/reglages">
      <h1 className={title}>{t('v2.abonnement.annule.title')}</h1>
      <p className={statusCard} role="status">
        {t('v2.abonnement.annule.status')}
      </p>
      <p className={lede}>{t('v2.abonnement.annule.lede')}</p>
      <Link to="/abonnement" className={linkStyle}>
        {t('v2.abonnement.annule.back')}
      </Link>
    </AppShell>
  );
}

export function AbonnementAnnuleScreen() {
  const gate = useBillingGate();
  if (gate === 'loading') return <GateLoadingScreen />;
  if (gate === 'denied') return <NotFoundScreen />;
  return <CheckoutCancelScreen />;
}
